/**
 * @function hypertext
 * @memberOf v3sWbtPlayerApp:page:elements
 * @description
 *
 * # Hypertext
 * Links auf Seiten, Lexikoneinträge oder ins WWW
 */

angular.module('v3sWbtPlayerApp').directive('v3sHypertext', ["v3sHypertextService", function (v3sHypertextService) {
    return {
        restrict: 'E',
        transclude: true,
        scope: {
            v3sFile: '@',
            v3sUrl: '@',
            v3sRefid: '@',
            v3sItemid: '@',
            v3sEntry: '@'
        },
        template: '<a ng-transclude></a>',
        link: function (scope, element, attrs, ctrl, transclude) {
            var updateLockState = function (locked) {
                if (locked) {
                    element.addClass("locked");
                } else {
                    element.removeClass("locked");
                }
            };

            v3sHypertextService.createLinkOnClick(
                element,
                {
                    itemId: scope.v3sItemid,
                    popupId: scope.v3sRefid,
                    filePath: scope.v3sFile,
                    url: scope.v3sUrl,
                    entry: scope.v3sEntry
                },
                scope,
                null,
                updateLockState);

        }
    }
}]);